import React from 'react'
import { useTranslation } from 'react-i18next'
import { PagingSidePanelType, Box as Section, SidePanel, Tabs } from '@node-space/ui-components'
import { appBannersId } from 'components/app/AppBanners'
import { useComponentHeight } from 'hooks/useComponentHeight'
import { highlightRowBasedOnId } from 'utils/table/table'
import { BillingSidePanelDetails } from './BillingSidePanelDetails'
import { BillingSidePanelHeader } from './BillingSidePanelHeader'
import { type Invoice } from './types'

interface BillingSidePanelProps {
  isOpen: boolean
  paging: PagingSidePanelType
  onClose: () => void
  invoice: Invoice | undefined
}

export const BillingSidePanel = ({ isOpen, paging, onClose, invoice }: BillingSidePanelProps) => {
  const { t } = useTranslation()
  const bannerSpacing = useComponentHeight(appBannersId)

  if (!invoice) return null

  return (
    <SidePanel
      id="side-panel-billing-details"
      isOpen={isOpen}
      paging={paging}
      onClose={onClose}
      activeRowId={invoice?.id}
      onActiveRowChange={highlightRowBasedOnId}
      externalStyle={{ top: `${bannerSpacing}px` }}
      header={<BillingSidePanelHeader invoice={invoice} />}
      body={
        <Section tag="section" width="full" background="layer-1">
          <Tabs
            tabs={[
              {
                id: 'details',
                header: t('details'),
                content: <BillingSidePanelDetails invoice={invoice} />,
                testId: 'billing-details-tab',
              },
            ]}
          />
        </Section>
      }
    />
  )
}
